import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  EffectCoverflow,
  Navigation,
  Pagination,
  Autoplay,
} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import Arrow from '../../../Images/icons/arrow-right.png';

const Slider = ({ slides }) => {
  return (
    <>
      <Swiper
        modules={[EffectCoverflow, Navigation, Pagination, Autoplay]}
        observer
        observeParents
        navigation={{
          prevEl: '.button-prev',
          nextEl: '.button-next',
        }}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        speed={600}
        slidesPerView={2}
        centeredSlides
        effect="coverflow"
        loop
        initialSlide={0}
        coverflowEffect={{
          rotate: 0,
          stretch: 80,
          depth: 120,
          modifier: 3,
          slideShadows: true,
        }}
        breakpoints={{
          0: {
            coverflowEffect: {
              rotate: 0,
              stretch: 10,
              depth: 230,
              modifier: 3,
            },
          },
          768: {
            coverflowEffect: {
              rotate: 0,
              stretch: 80,
              depth: 120,
              modifier: 3,
            },
          },
        }}
      >
        {slides.map((slide, key) => (
          <SwiperSlide className="slide-inner" key={key}>
            <div className="slide-inner__container">
              <img src={slide.img} alt={slide.altText} />
            </div>
          </SwiperSlide>
        ))}

        <div className="button-container">
          <div className="button-prev">
            <img src={Arrow} alt="left" />
          </div>
          <div className="button-next">
            <img src={Arrow} alt="Right" />
          </div>
        </div>
      </Swiper>
    </>
  );
};

export default Slider;
